module.exports = __webpack_public_path__ + "img/product_102.74b909a.webp";